import "./style.less";

export default function HeaderMobile(asideFactory) {
    return {
        restrict: "E",
        scope: {},
        template: require("./template.html"),

        controller: function ($scope, $location, $timeout, $window) {
            $scope.reloadApp = function () {
                $location.path("/");

                $timeout(function () {
                    $window.location.reload();
                });
            };

            // used in header // is this the navigation items??
            // siteService.getMenuNodes().then(function (nodes) {

            //     $scope.nodes = nodes;
            // });
            // Used to exclude example: unavailable places when specific activity is selected

            // console.log(localStorageService.get('currentBookings'));

            // if(localStorageService.get('currentBookings')){
            //     console.log('currentBookings refilled from localStorage');
            //     console.log(localStorageService.get('currentBookings') );
            //     Basket.currentBookings = localStorageService.get('currentBookings');
            // }
        },
    };
}
